import { useSuspenseQuery } from "@tanstack/react-query";
import { CabecalhoPagina, Tela } from "@/components/casca/CabecalhoPagina";
import { Vazio } from "@/components/casca/Vazio";
import { TabelaPacientes } from "@/components/pacientes/TabelaPacientes";
import { pacientesQuery } from "../consultas";

/** Todo mundo que já falou com a clínica, com a jornada de cada um — e a campanha. */
export function Pacientes() {
  const {
    data: { pacientes, interesses, total, modelos },
  } = useSuspenseQuery(pacientesQuery());

  if (pacientes.length === 0) {
    return (
      <Tela>
        <CabecalhoPagina titulo="Pacientes" descricao="Todo mundo que já falou com a clínica." />
        <Vazio icone="pacientes" titulo="Nenhum paciente ainda">
          A primeira conversa cria a primeira ficha. Aqui você busca por nome ou telefone, vê a jornada de cada um e dispara
          campanha para quem faz sentido.
        </Vazio>
      </Tela>
    );
  }

  return <TabelaPacientes pacientes={pacientes} interesses={interesses} total={total} modelos={modelos} />;
}
